// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"singleFamilyProperty":{"f":""},"price":{"f":""},"multiUnitProperty":{"f":""},"mlsPlan":{"f":""},"lotProperty":{"f":""},"condoProperty":{"f":""},"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayPreviewPropertyDetails_displayHelpers",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": [
            {
              "kind": "Literal",
              "name": "priceFormat",
              "value": "FULL"
            },
            {
              "kind": "Literal",
              "name": "priceRangeFormat",
              "value": "FULL"
            }
          ],
          "kind": "FragmentSpread",
          "name": "PropertyPrice_propertyPrice"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LeaseLengthV5",
      "kind": "LinkedField",
      "name": "leaseLength",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CondoProperty",
      "kind": "LinkedField",
      "name": "condoProperty",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ForSalePropertyAttributesCondo_condoProperty"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LotProperty",
      "kind": "LinkedField",
      "name": "lotProperty",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ForSalePropertyAttributesLot_lotProperty"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MultiUnitProperty",
      "kind": "LinkedField",
      "name": "multiUnitProperty",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ForSalePropertyAttributesMultiUnit_multiUnitProperty"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SingleFamilyProperty",
      "kind": "LinkedField",
      "name": "singleFamilyProperty",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ForSalePropertyAttributesSingleFamily_singleFamilyProperty"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "mlsPlan",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AgentPropertyMlsStatus_mlsPlan"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardRelayPreviewPropertyDetailsStreetAddress_displayHelpers"
    }
  ],
  "type": "PropertyPreviewHelpers",
  "abstractKey": null
};
})());

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
